export default "__VITE_ASSET__CU4BtQm2__"